<div class="legal-page">
  <a class="legal-page__back" href="/registration">
    <mat-icon style="font-size:1rem;width:1rem;height:1rem">arrow_back</mat-icon>
    Zurück zur Registrierung
  </a>

  <h1 class="legal-page__title">Allgemeine Geschäftsbedingungen</h1>
  <p class="legal-page__date">Stand: April 2026</p>

  <div class="legal-page__body">
    <h2>§ 1 Geltungsbereich</h2>
    <p>
      Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der
      Software-as-a-Service-Plattform Docuty, angeboten von der Insirion GmbH.
    </p>

    <h2>§ 2 Vertragsgegenstand</h2>
    <p>
      Docuty ist eine cloudbasierte Plattform zur mobilen Dokumentation und Verwaltung
      von Begehungen, Inspektionen und Audits. Der Funktionsumfang richtet sich nach
      dem gewählten Tarif.
    </p>

    <h2>§ 3 Vertragsschluss</h2>
    <p>
      Der Vertrag kommt durch die Registrierung auf der Plattform und die Auswahl
      eines Tarifs zustande. Mit dem Abschluss der Registrierung erklärt der Nutzer
      seine Zustimmung zu diesen AGB.
    </p>

    <h2>§ 4 Leistungen und Verfügbarkeit</h2>
    <p>
      Insirion GmbH stellt die Plattform im Rahmen der technischen und
      betrieblichen Möglichkeiten zur Verfügung. Eine ununterbrochene Verfügbarkeit
      kann nicht garantiert werden.
    </p>

    <h2>§ 5 Nutzerpflichten</h2>
    <p>
      Nutzer sind verpflichtet, ihre Zugangsdaten vertraulich zu behandeln und
      ausschließlich rechtmäßig erhobene Daten in die Plattform einzupflegen.
    </p>

    <h2>§ 6 Kündigung</h2>
    <p>
      Abonnements können jederzeit zum Ende des laufenden Abrechnungszeitraums
      über die Kontoeinstellungen gekündigt werden.
    </p>

    <h2>§ 7 Haftungsbeschränkung</h2>
    <p>
      Die Haftung von Insirion GmbH ist auf Vorsatz und grobe Fahrlässigkeit
      beschränkt, soweit gesetzlich zulässig.
    </p>

    <h2>§ 8 Anwendbares Recht</h2>
    <p>
      Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
      Gerichtsstand ist der Sitz von Insirion GmbH.
    </p>
  </div>
</div>
